<template>
  <div class="signUp" v-loading.fullscreen.lock="fullscreenLoading">
    <Banner :competition="competition"></Banner>
    <div>
      <div class="content">
        <div class="title">
          <img src="../../assets/saishianpai-title-icon.png" alt="" />
          <p class="tit">比赛报名</p>
          <div style="display: flex" v-if="isSign">
            <p class="state audit" v-if="status == 0">审核中</p>
            <p class="state success" v-if="status == 1">报名成功</p>
            <p class="state reject" v-if="status == 2">已驳回</p>
          </div>
        </div>
        <div class="reason" v-if="isSign && status == 2">
          {{ refuseReason || "暂无" }}
        </div>
        <div class="notice" v-if="isSign && notice">
          {{ notice }}
        </div>
        <div class="form">
          <el-form
            ref="ruleForm"
            :model="ruleForm"
            label-width="120px"
            size="medium"
          >
            <el-form-item
              :prop="`fieldList.${index}.value_txt_${item.id}`"
              :rules="getRules(item)"
              :label="item.title"
              v-for="(item, index) in ruleForm.fieldList"
              :key="item.id"
            >
              <!-- 手机号 0 -->
              <el-input
                v-if="item.type == 0"
                v-model="item[`value_txt_${item.id}`]"
                placeholder="请输入手机号"
                maxlength="11"
                :readonly="status == 1 || status == 0 || isToken"
              ></el-input>
              <!-- 姓名 1 -->
              <el-input
                v-if="item.type == 1"
                v-model="item[`value_txt_${item.id}`]"
                placeholder="请输入姓名"
                maxlength="50"
                :readonly="status == 1 || status == 0"
              ></el-input>
              <!-- 身份证号 2 -->
              <div class="idcard" v-if="item.type == 2">
                <el-select
                  :disabled="status == 1 || status == 0"
                  v-model="item.extContent"
                  placeholder="请选择证件类型"
                  style="width: 30%"
                  clearable
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-input
                  style="width: 69%"
                  v-model="item[`value_txt_${item.id}`]"
                  placeholder="请输入证件号"
                  maxlength="18"
                  :readonly="status == 1 || status == 0"
                ></el-input>
              </div>
              <!-- 邮箱 3 -->
              <el-input
                v-if="item.type == 3"
                v-model="item[`value_txt_${item.id}`]"
                placeholder="请输入邮箱"
                maxlength="100"
                :readonly="status == 1 || status == 0"
              ></el-input>
              <!-- 日期 7 -->
              <el-date-picker
                type="date"
                v-if="item.type == 7"
                placeholder="选择日期"
                v-model="item[`value_txt_${item.id}`]"
                style="width: 100%"
                value-format="yyyy-MM-dd"
                :readonly="status == 1 || status == 0"
              ></el-date-picker>
              <!-- 自定义文本 8 -->
              <el-input
                v-if="item.type == 8"
                v-model="item[`value_txt_${item.id}`]"
                placeholder="请输入"
                maxlength="200"
                :readonly="status == 1 || status == 0"
              ></el-input>
              <!-- 自定义单选 -->
              <el-radio-group
                :disabled="status == 1 || status == 0"
                v-if="item.type == 9"
                v-model="item[`value_txt_${item.id}`]"
              >
                <el-radio
                  :label="itemRadio"
                  v-for="itemRadio in item.optionList"
                  :key="itemRadio"
                ></el-radio>
              </el-radio-group>
              <!-- 自定义多选 -->
              <el-checkbox-group
                :disabled="status == 1 || status == 0"
                v-if="item.type == 10"
                v-model="item[`value_txt_${item.id}`]"
              >
                <el-checkbox
                  @change.native="checkedChange"
                  :label="itemCheckbox"
                  v-for="itemCheckbox in item.optionList"
                  :key="itemCheckbox"
                  >{{ itemCheckbox }}</el-checkbox
                >
              </el-checkbox-group>
              <!-- 文件 6 -->
              <el-upload
                v-if="item.type == 6 && status != 1 && status != 0"
                class="upload-demo"
                :action="action"
                multiple
                :disabled="status == 1 || status == 0"
                :limit="1"
                :on-exceed="handleExceed"
                :on-preview="handlePreview"
                :file-list="item[`value_txt_${item.id}`]"
                :on-remove="
                  (response, file, fileList) => {
                    return handleRemove(response, file, fileList, item);
                  }
                "
                :on-success="
                  (response, file, fileList) => {
                    return handleSuccess(response, file, fileList, item);
                  }
                "
              >
                <el-button
                  size="small"
                  type="primary"
                  v-if="status != 1 || status != 0"
                  >点击上传</el-button
                >
                <div
                  slot="tip"
                  class="el-upload__tip"
                  v-if="status != 1 || status != 0"
                >
                  只能上传一个文件！
                </div>
              </el-upload>
              <div
                class=""
                v-if="item.type == 6 && (status == 1 || status == 0)"
              >
                <p
                  style="
                    cursor: pointer;
                    color: #fff;
                    font-size: 14px;
                    line-height: 36px;
                  "
                  v-for="i in item[`value_txt_${item.id}`]"
                  :key="i.uid"
                >
                  {{ i.name }}
                  <span
                    @click="downloadFile(i)"
                    style="
                      color: #d0021b;
                      text-decoration: underline;
                      padding-left: 10px;
                    "
                    >查看</span
                  >
                </p>
              </div>
            </el-form-item>
            <el-form-item v-if="status == null || status == 2">
              <p class="submit" @click="submitForm('ruleForm')">
                {{ status == 2 ? "重新" : "" }}提交报名信息
              </p>
              <p class="tip">信息一旦提交不可修改，请仔细核对</p>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/banner";
import { getSignUpDetail, commitApplication } from "../../api/index";
export default {
  name: "SignUp",
  components: { Banner },
  data() {
      const baseApi = process.env.VUE_APP_BASE_API?.trim() || `${window.location.origin}/api`;
      return {
      options: [
        {
          value: "0",
          label: "身份证",
        },
        {
          value: "1",
          label: "港澳通行证",
        },
        {
          value: "2",
          label: "护照",
        },
        {
          value: "3",
          label: "其他",
        },
      ],
      isToken: false,
      competition: JSON.parse(sessionStorage.getItem("competition")), //赛事详情
      ruleForm: {
        competitionId: this.$route.query.competitionId, //比赛ID
        fieldList: [],
      },
      isSign: false, //是否报名
      action: `${baseApi}/client/file/upload`,
      status: null, //审核状态
      refuseReason: "", //驳回原因
      notice: "", //专属信息
      fullscreenLoading: false, //全局加载状态
    };
  },
  created() {
    this.isToken = localStorage.getItem("TOKEN") ? true : false;
    this.getSignUpDetail();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    //查看文件
    downloadFile(i) {
      window.location.href = i.name;
    },
    //校验规则
    getRules(item) {
      const rules = [
        {
          required: item.isRequired === 1,
          message: "请完善信息",
          trigger:
            item.type === 0 ||
            item.type === 1 ||
            item.type === 2 ||
            item.type === 3 ||
            item.type === 8
              ? "blur"
              : "change",
        },
        {
          pattern:
            item.type == 0
              ? /^1[0123456789]\d{9}$/
              : item.type == 2 && item.extContent == "0"
              ? /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
              : item.type == 3
              ? /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              : /^.*$/,
          message: "格式不正确",
          trigger: "blur",
        },
      ];
      return rules;
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let msg = JSON.stringify(this.ruleForm);
          let data = JSON.parse(msg);
          let extContentBool = true;
          data.fieldList.map((item) => {
            if (item.type == 2) {
              //证件号
              if (item[`value_txt_${item.id}`]) {
                if (!item.extContent) {
                  extContentBool = false;
                }
              }
            }
            if (item.type == 6) {
              item.value = item[`value_txt_${item.id}`][0].response
                ? item[`value_txt_${item.id}`][0].response.msg
                : item[`value_txt_${item.id}`][0].url;
            } else if (item.type == 10) {
              item.value = item[`value_txt_${item.id}`].toString();
            } else {
              item.value = item[`value_txt_${item.id}`];
            }
            delete item[`value_txt_${item.id}`];
          });
          if (!extContentBool) {
            this.$message.error("请选择证件类型");
            return;
          }
          this.$confirm("确定提交?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            this.fullscreenLoading = true;
            commitApplication(data)
              .then(() => {
                this.fullscreenLoading = false;
                this.$message.success("报名成功！");
                this.getSignUpDetail();
              })
              .catch(() => {
                this.fullscreenLoading = false;
              });
          });
        }
      });
    },
    //动态渲染复选框
    checkedChange() {
      // 方法
      this.$forceUpdate();
    },
    handlePreview(file) {
      window.location.href = file.response.msg;
    },
    //删除文件
    handleRemove(response, file, fileList, item) {
      console.log(response, file, fileList, item);
      this.$set(item, `value_txt_${item.id}`, []);
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList, item) {
      item.value = response.msg;
      console.log(response, file, fileList, item);
      this.$set(item, `value_txt_${item.id}`, fileList);
      this.$forceUpdate();
    },
    handleExceed() {
      this.$message.error("只能上传一个文件！");
    },
    //报名信息
    getSignUpDetail() {
      let params = {
        competitionId: this.$route.query.competitionId,
      };
      this.fullscreenLoading = true;
      getSignUpDetail(params)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.code == 200001) {
            //未报名
            this.isSign = false;
            this.ruleForm.fieldList = res.data;
            this.ruleForm.fieldList.map((item) => {
              if (item.type == 0 && this.isToken) {
                //手机号
                let userInfo = JSON.parse(localStorage.getItem("USERINFO"));
                this.$set(item, `value_txt_${item.id}`, userInfo.phone);
              } else if (item.type == 10 || item.type == 6) {
                this.$set(item, `value_txt_${item.id}`, []);
              } else {
                this.$set(item, `value_txt_${item.id}`, "");
              }
            });
          } else if (res.code == 200002) {
            // 已报名 数据回显
            this.status = res.data.application.status;
            this.refuseReason = res.data.application.refuseReason;
            this.notice = res.data.application.notice;
            res.data.applicationFieldsWithValue.map((item) => {
              if (item.type == 10) {
                item[`value_txt_${item.id}`] = item.value.split(",");
              } else if (item.type == 6) {
                item[`value_txt_${item.id}`] = [];
                let obj = {
                  uid: Date.now(),
                  url: item.value,
                  name: item.value,
                };
                item[`value_txt_${item.id}`].push(obj);
              } else {
                item[`value_txt_${item.id}`] = item.value;
              }
            });
            this.ruleForm = {
              competitionId: this.$route.query.competitionId,
              fieldList: res.data.applicationFieldsWithValue,
            };
            this.isSign = true;
          }
        })
        .catch(() => {
          this.fullscreenLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.idcard {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
::v-deep .el-input.is-disabled .el-input__inner {
  background: transparent;
}
::v-deep .upload-demo .el-upload-list__item:hover {
  background-color: transparent !important; /* 修改鼠标划过时的背景色 */
}
::v-deep .el-icon-close {
  color: #fff !important; /* 修改删除按钮的颜色 */
}
::v-deep .el-radio__inner::after {
  background: #046bde !important;
}
::v-deep .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after {
  /* 修改禁用状态下对勾的颜色 */
  /* background-color: #046bde; */
  border-color: #046bde;
}
::v-deep .el-upload-list__item-name {
  color: #fff;
}
.reason {
  width: 649px;
  background: #fee6e6;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #d0021b;
  line-height: 14px;
  padding: 13px;
  margin: 54px 0 0 220px;
}
.notice {
  width: 649px;
  background: #e6f2ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  color: #046bde;
  line-height: 14px;
  padding: 13px;
  margin: 20px 0 0 220px;
}
.reject {
  background: #a22d3b;
}
.audit {
  background: #046bde;
}
.success {
  background: #00b1a2;
}
::v-deep .el-radio__label {
  color: #fff;
}
::v-deep .el-checkbox__label {
  color: #fff;
}
.state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 30px;
  font-size: 20px;
  font-weight: 600;
  color: #ffffff;
  line-height: 28px;
  border-radius: 20px;
  margin-left: 30px;
}
::v-deep .el-upload__tip {
  color: #fff;
}
.tip {
  font-size: 14px;
  font-weight: 400;
  color: #788a9f;
  line-height: 22px;
  margin-top: 20px;
}
.submit {
  width: 180px;
  height: 40px;
  background: #046bde;
  border-radius: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #ffffff;
  line-height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-input__inner {
  border-radius: 4px;
  border: 1px solid #e9ecf2;
  background: none;
  color: #fff;
}
::v-deep .el-form-item {
  margin-bottom: 30px;
}
::v-deep .el-form-item__label {
  font-size: 14px;
  font-weight: 400;
  color: #ffffff;
}
.form {
  padding: 54px 200px 0 100px;
}
.title {
  display: flex;
  align-items: center;
}
.title img {
  width: 42px;
}
.title .tit {
  font-size: 40px;
  font-weight: 600;
  color: #ffffff;
  line-height: 40px;
  margin-left: 24px;
}
.content {
  width: 1180px;
  min-height: 713px;
  margin: 0 auto;
  background: #0a2b51;
  border-radius: 20px;
  border: 1px solid #046bde;
  margin-top: -80px;
  padding: 55px 54px 50px;
  margin-bottom: 150px;
  position: relative;
}
.signUp {
  display: flex;
  flex-direction: column;
  background: #171f30;
}
</style>
